export enum CALL_FOR_CAPITAL_TYPE {
  ADF_1 = 'adf-1',
  ADF_2 = 'adf-2',
  ADF_3 = 'adf-3',
  ADF_4 = 'adf-4',
}
